import { Pipe, PipeTransform } from '@angular/core';
import { countryList } from './country-list';

@Pipe({
  name: 'caCountryFlagCode',
  standalone: false
})
export class CountryFlagCodePipe implements PipeTransform {
  transform(countryCode: string): string {
    return countryList[countryCode];
  }
}
